<template>
  <div>
    <IconTable :icon-heading-list="iconHeadingList"></IconTable>
  </div>
</template>

<script lang="ts" setup>
import IconClock from '~/components/icons/IconClock'
import IconTranslate from '~/components/icons/IconTranslate'
import IconInfoCircle from '~/components/icons/IconInfoCircle'
import IconListCheck from '~/components/icons/IconListCheck'
import IconPeopleFill from '~/components/icons/IconPeopleFill'
import type { EventDescription } from '~/composables/types/event'
import { IconGlobeCentralSouthAsia } from '#components'

const props = withDefaults(
  defineProps<{
    eventDetails: EventDescription | null
  }>(),
  {
    eventDetails: null,
  }
)
const { t } = useI18n()

const eventData = toRef(() => props.eventDetails)
const iconHeadingList = [
  [
    {
      iconComp: IconListCheck,
      label: t('product.show.boxDetails.summaryWhatIsIncluded'),
      description: eventGetters.getWhatIsIncludedSummary(eventData.value),
    },
  ],
  [
    {
      iconComp: IconInfoCircle,
      label: t('product.show.boxDetails.summaryMoreDetails'),
      description: eventGetters.getLocationSummary(eventData.value),
    },
  ],
]
</script>
